import React, { useState, useMemo, useEffect } from "react";
import HeaderComponents from "../../components/HeaderComponents";
import AccountsSection from "../../components/Overview/AccountsSection";
import OverviewAccountSkeleton from "../../components/skeletons/OverviewAccountSkeleton";
import OverviewSection from "../../components/Overview/OverviewSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { useTable } from "react-table";
import Table from "../../components/Table";
import { capitalizeFirstLetters } from "../../features/ValueFormater";
import "../../utils/Style/pages/OutOfDelivery.scss"
import useOrderProcessingApi from "../../api/OrderProcessingApi";
import useDeliveryOrderApi from "../../api/DelivaryOrderApi";
import TransferListSkeleton from "../../components/skeletons/TransferListSkeleton";
import Pagination from "../../components/Pagination";
import RecordsMessage from "../../components/RecordsMessage";
import UtcToLocal from "../../components/UtcToLocal";

function OutOfDelivery({ method }) {
    const [loading, setLoading] = useState(false);
    const [activeRowIndex, setActiveRowIndex] = useState(-1);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedPage, setSelectedPage] = useState(1);
    const [month, setMonth] = useState("ThisMonth");
    const [orders, setOrders] = useState([]);
    const [selectedOrderType, setSelectedOrderType] = useState("");

    const { GetOrderTypes, orderTypes } = useOrderProcessingApi();
    const { GetOutForDeliveryOrders, outForDeliveryOrders, outofDeliveryLoading, totalNbOfPage, totalCount } = useDeliveryOrderApi();

    const [dateRange, setDateRange] = useState([
        new Date(new Date().setMonth(new Date().getMonth() - 1)),
        new Date(),
    ]);

    const [dateString, setDateString] = useState({
        startDateString: "",
        endDateString: ""
    });

    useEffect(() => {
        GetOrderTypes();
    }, [])

    useEffect(() => {
        if (orderTypes) {
            setOrders(orderTypes);
        }
    }, [orderTypes]);

    useEffect(() => {
        if (dateRange && dateRange.length === 2) {
            const [start] = dateRange;
            const end = new Date();

            if (start && !isNaN(start) && !isNaN(end)) {
                const startDate = new Date(Date.UTC(start.getUTCFullYear() - 1, start.getUTCMonth(), start.getUTCDate()));
                const endDate = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate()));

                const startDateString = startDate.toISOString().substring(0, 10);
                const endDateString = endDate.toISOString().substring(0, 10);

                setDateString({
                    startDateString,
                    endDateString
                });

                GetOutForDeliveryOrders(1, startDateString, endDateString, 0);
            }
        }
    }, [dateRange]);

    const options = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    };

    const columns = useMemo(() => [
        {
            Header: "Order ID",
            accessor: "orderId",
        },
        {
            Header: "Client Full Name",
            accessor: "clientFullName",
        },
        {
            Header: "",
            accessor: "details",
            Cell: ({ row }) => (
                <button className="showmore" onClick={() => setActiveRowIndex(row.index)}>
                    <FontAwesomeIcon icon={faArrowDown} />
                </button>
            ),
        },
        {
            Header: "Phone Number",
            accessor: "phoneNumber",
        },
        {
            Header: "Currency",
            accessor: "currency",
        },

        {
            Header: "Amount",
            accessor: "amount",
            Cell: ({ cell: { value, row } }) => {
                const currencySymbol = row.original.currency === "USD" ? "$" : "L.L"
                return (
                    <div style={{ fontFamily: "Poppins SemiBold" }}>
                        {currencySymbol} {value}
                    </div>
                );
            }
        },
        {
            Header: "Date",
            accessor: "date",
            Cell: ({ cell: { value } }) => {
                return <UtcToLocal utcTimestamp={value} options={options} />
            },
        },
        {
            Header: "Time",
            id: "time",
            accessor: "date",
            Cell: ({ cell: { value } }) => {
                const date = new Date(value);
                return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            },
        },
        {
            Header: "Status",
            accessor: "status",
            Cell: ({ cell: { value } }) => {
                if (["to cashroom", "to client"].includes(value.toLowerCase())) {
                    return <div className={"status " + value?.toUpperCase()}>{capitalizeFirstLetters(value)}</div>
                }
            }
        },
        {
            Header: "Pick Up Time",
            accessor: "pickUpTime"
        },
        {
            Header: "Expected Delivery",
            accessor: "expectedDelivery"

        },
        {
            Header: "",
            accessor: "others",
            Cell: ({ row }) => {
                return (
                    <button className="call-btn">View Location</button>
                )
            }
        },
    ], []);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data: outForDeliveryOrders });


    const filteredRows = rows.filter((row) => {
        const orderTypeMatch = selectedOrderType === "" || row.original.type === selectedOrderType;
        const searchQueryMatch = Object.values(row.original).some((cellValue) =>
            cellValue.toString().toLowerCase().includes(searchQuery.toLowerCase())
        );
        return orderTypeMatch && searchQueryMatch;
    });

    return (
        <>
            <div className="OutOfDeliveryPage">
                <HeaderComponents title="Out Of Delivery" />
                <div className="OutOfDeliveryPageContainer">
                    <div className="table-container">
                        <div className="tableTop">
                            <RecordsMessage
                                totalCount={totalCount}
                                selectedPage={selectedPage}
                                records="Orders"
                            />
                            <div className="filtering">
                                <div className="filteringSearch">
                                    <input
                                        className="search"
                                        placeholder="Search"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)} />
                                    <span className="iconSearch"><FontAwesomeIcon icon={faMagnifyingGlass} /></span>
                                </div>
                                <select
                                    className="ddselect"
                                    name="order"
                                    id="order"
                                    value={selectedOrderType}
                                    onChange={(e) => {
                                        setSelectedOrderType(e.target.value)
                                    }}
                                >
                                    <option value="">All Orders</option>
                                    {orders.map(order => (
                                        <option key={order.value} value={order.value}>
                                            {order.label}
                                        </option>
                                    ))
                                    }
                                </select>
                            </div>

                        </div>
                        <div className="row">
                            {outofDeliveryLoading ? (
                                <TransferListSkeleton />
                            ) : (
                                <>
                                    <Table
                                        headerGroups={headerGroups}
                                        page={filteredRows}
                                        prepareRow={prepareRow}
                                        getTableProps={getTableProps}
                                        getTableBodyProps={getTableBodyProps}
                                        activeRowIndex={activeRowIndex}
                                        setActiveRowIndex={setActiveRowIndex}
                                    />
                                    <Pagination
                                        getData={GetOutForDeliveryOrders}
                                        totalNbPage={totalNbOfPage}
                                        method="outOfDelivery"
                                        case={method}
                                        startDateString={dateString.startDateString}
                                        endDateString={dateString.endDateString}
                                        selectedPage={selectedPage}
                                        setSelectedPage={setSelectedPage}
                                    />
                                </>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OutOfDelivery;
